import Vue from 'vue'
import Vuex from 'vuex'

import { setUserLanguage, getUserLanguage, setShowCookiesPolicy, getShowCookiesPolicy } from '../utils/cookiesConfig.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    language: getUserLanguage(),
    showCookiesPolicy: getShowCookiesPolicy(),
    channelInfo: {},
    latestVideos: [],
    games: [],
  },
  mutations: {
    setStateUserLanguage(state, language) {
      state.language = language;
      setUserLanguage(state.language);
    },
    setStateShowCookiesPolicy(state, showCookiesPolicy) {
      state.showCookiesPolicy = showCookiesPolicy;
      setShowCookiesPolicy(state.showCookiesPolicy);
    },
    setChannelInfo(state, channelInfo) {
      state.channelInfo = channelInfo;
    },
    setLatestVideos(state, latestVideos) {
      state.latestVideos = latestVideos;
    },
    setGames(state, games) {
      state.games = games;
    },
  },
  actions: {
    setStateUserLanguage({ commit }, language) {
      commit('setStateUserLanguage', language);
    },
    setStateShowCookiesPolicy({ commit }, showCookiesPolicy) {
      commit('setStateShowCookiesPolicy', showCookiesPolicy);
    },
    setChannelInfo({ commit }, channelInfo) {
      commit('setChannelInfo', channelInfo);
    },
    setLatestVideos({ commit }, latestVideos) {
      commit('setLatestVideos', latestVideos);
    },
    setGames({ commit }, games) {
      commit('setGames', games);
    },
  },
  getters: {
  }
})
